/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Басты',
	myContent: 'Mенің мазмұным',
	teamContent: 'Топтық мазмұн',
	folder: 'Қалта',
	files: 'Файлдар',
	actionMenu: 'Әрекет мәзірі',
	myFolder: 'Жеке қалталарым',

	emptyFolderNoContent: 'Мазмұн жоқ',

	//EmptyStates
	emptyRecentTitle: 'Жақын арада ешбір мазмұнды көрмедіңіз.',
	emptyStateTitle: 'Деректерді қосудан бастаңыз',
	emptyStateBody: 'Жоғарыдағы деректерді жүктеу түймесін басыңыз немесе деректерді жүктеу үшін сүйреп апарыңыз.',
	emptySearchResultTitle: 'Хм, сіздің іздеуіңіз нәтиже берген жоқ.',
	emptyPortalTitle: 'Порталдар жоқ',
	emptyPortalBody: 'Қазіргі уақытта сізде ешқандай портал жоқ.',
	emptyWsProjectTitle: 'Watson Studio бағдарламасында notebook құрудан бастаңыз.',
	emptyWsProjectBody: 'Cognos Analytics бағдарламасына оралғанда, сіздің notebook осында пайда болады.',
	emptyFilteredResultTitle: 'Хм, қолданылған сүзгілер нәтиже бермеді.',
	emptyDialogViewTitle: 'Элементтер жоқ',
	removeFromRecents: 'Соңғысынан алып тастау',

	// Welcome Banner
	welcomeBannerGreeting: 'Сәлем. Cognos Analytics бағдарламасына қош келдіңіз.',
	welcomeBannerDescription: 'Cognos Analytics пайдаланушыларға AI-ге негізделген өзіндік қызмет талдауларымен мүмкіндік береді. Автоматтандырылған деректерді дайындау, деректерді табу және көрнекілендіру сенімді шешімдер қабылдауға қаншалықты ықпал ететінін қараңыз.',
	welcomeBannerDescription_trialUser: 'Біздің кіріспе бейнемізді, өнімге шолу және Жұмысқа кірісу қойындысын көру арқылы бірден бастауға болады.',
	takeTourButtonLabel: 'Өнім турына барыңыз',
	watchVideoButtonLabel: 'Бейнені қараңыз',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Үй парағынан құттықтау баннерін өшіргіңіз келетініне сенімдісіз бе? Мұны кез келген уақытта Профиль және параметрлер > Параметрлер > Жалпы бөлімінен қосуға болады. ',
	hideWelcomeBannerTitle: 'Қош келдіңіз баннерін өшіріңіз',
	ok: 'OK',
	cancel: 'Болдырмау',
	//howto video dialog
	modal_how_title: 'Бейнелерді қалай',
	modal_overview_title: 'Cognos Analytics шолуын қараңыз',
	modal_how_play: 'Бейнені ойнату',
	modal_how_video_title_overview: 'Жалпы шолу',
	modal_how_video_title_getStarted: '11.2-де жұмысқа кірісу',
	modal_how_video_title_newUI: 'Жаңа Cognos тәжірибесіне қош келдіңіз',
	modal_how_video_title_dataModule: 'Деректер модульдеріне шолу',
	modal_how_video_title_explore: 'Деректерді зерттеуге шолу',
	modal_how_video_title_dashboard: 'Интерактивті бақылау тақталарына шолу',
	modal_how_video_title_reporting: 'Есеп беруге шолу',
	modal_how_video_title_mobile: 'Cognos күші сіздің алақаныңызда',

	// Toolbar
	search: 'Іздеу',
	addFolder: 'Қалтаны қосу',
	addLink: 'Сілтеме қосу',
	filter: 'Сүзгі',
	sort: 'Сұрыптау',
	settings: 'Параметрлер',
	tilesView: 'Тақтайша көрінісі',
	listView: 'Тізім көрінісі',
	columnView: 'Баған көрінісі',

	// Toolbar Actions
	sortBy: 'Сұрыптау әдісі',
	sortOrder: 'Реттеу',
	name: 'Аты',
	modifiedTime: 'Өзгертілген',
	type: 'Түрі',
	ascending: 'Артуы бойынша',
	descending: 'Кемуі бойынша',

	filterType: 'Түрі',
	filterModificationTime: 'Өзгертілген',
	all: 'Барлық',
	today: 'Бүгін',
	yesterday: 'Кеше',
	pastWeek: 'Өткен апта',
	pastMonth: 'Өткен ай',
	resetFilters: 'Сүзгілерді қалпына келтіру',

	filterSearchPlaceHolder: 'Кілт сөздер бойынша сүзгілеңіз',

	resetFilterTag: 'Сүзгілерді қалпына келтіру үшін X батырмасын басыңыз.',
	filterTagToolTip: 'Қолданылған сүзгілер: %{appliedFilters}.',

	folderName: 'Қалта атауы',
	addAFolder: 'Қалтаны қосу',
	add: 'Қосу',
	error: 'Қате',
	newFolderDefaultName: 'Жаңа қалта',
	toastCreateNewFolder: '%{nameOfFolder} қалтасы %{tabName}-да жасалған.',
	folderAdded: 'Қалта қосылды',
	refresh: 'Жаңарту',
	openFolder: 'Қалтаны ашу',

	addAUrl: 'URL мекен-жайын қосу',
	linkName: 'URL мекен-жайын атауы',
	linkNamePlaceholder: 'URL мекен-жайын қосу',
	linkDescription: 'Сипаттама (таңдамалы)',
	linkDescriptionPlaceholder: 'Сипаттама қосыңыз',
	linkUri: 'URL мекен-жайы',
	linkUriPlaceholder: 'Қолайлы доменмен URL мекен-жайын қосыңыз',
	acceptableDomains: 'Рұқсат етілген домендер',
	viewAcceptableDomains: 'Рұқсат етілген домендерді көрсетіңіз',
	mandatoryField: 'Міндетті өріс',
	linkAdded: 'URL мекен-жайы қосылды',
	toastCreateNewLink: '%{nameOfLink} элементі %{tabName}-ге қосылды.',
	noEntries: 'Қолайлы домендер тізімінде жазбалар жоқ. Әкімшіңізге хабарласыңыз.',

	compact: 'Ықшам',
	short: 'Қысқа',
	default: 'Әдепкі',
	rowSize: 'Жол өлшемі',

	// GroupyByTypes
	folders: 'Қалталар',
	reports: 'Есептер',
	dashboards: 'Бақылау тақталары',
	data: 'Деректер',
	packages: 'Бумалар',
	explorations: 'Барлаулар',
	stories: 'Мақалалар',
	notebooks: 'Жазу кітаптар',
	others: 'Басқа',

	// Error Messages
	itemsOverLimit: '"%{itemName}" көрсетілген атау ең жоғары (20) шегінен асып кетті. Жалғастыру үшін басқа атауды көрсетіңіз.',
	errorMessageLengthFolderName: '255 таңбадан аспайтын қалта атауын енгізіңіз.',
	errorMessageLengthLinkName: '255 таңбадан аспайтын сілтеме атауын енгізіңіз.',
	toastLaunchPerspectiveError: '%{objectType} нысанын аша алмады.',
	errorNoAccessTitle: 'Хм, бұл мазмұнға кіруге рұқсатыңыз жоқ сияқты',
	errorNoAccessBody: 'Әкімшіңізге хабарласыңыз немесе келесі сілтемені қараңыз:',
	errorEnableExternalContent: 'Сыртқы мазмұнды қосу',

	//TableHeader
	lastModified: 'Соңғы өзгертілген',
	location: 'Орны',
	tenant: 'Қатысушы',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics бағдарламасында жұмыс істеңіз',
	learningHowToLabel: 'Оқу ресурстары',
	learningHowToDescription: 'Білімді кеңейтіп, қауымдастықпен байланыс орнату, құжаттарды оқу және бейнелерді көру арқылы көмек алыңыз.',
	learningHowToActionLabel: 'Оқу аумағын іске қосыңыз',
	howToVideosLabel: 'Тәжірибелік ұсыныстары бар бейнелер',
	howToVideosDescription: 'IBM Cognos Analytics-ті қалай пайдалану керектігін біліп, деректеріңіз туралы түсінік ала бастаңыз.',
	howToVideosActionLabel: 'Бейнелерді қараңыз',
	acceleratorCatalogLabel: 'Accelerator каталогы',
	acceleratorCatalogDescription: 'Өсіп келе жатқан өнеркәсіптік каталогты, ең жақсы тәжірибелік нұсқаулықтарды, жеке көрнекіліктерді және басқаларын шолыңыз.',
	acceleratorCatalogActionLabel: 'Каталогты шолу',
	sampleSectionTitle: 'Үлгілер',
	sampleSectionDescription: 'Cognos Analytics ұсынатын барлық нәрселерді көрсететін мысалдармен тәжірибе жасаңыз.',
	// Samples Section
	createDashboardSampleTitle: 'Бірінші бақылау тақтасын қалай жасауға болады',
	createDashboardSampleDescription: 'Талдау сапарыңызды Cognos Dashboards тақталарынан бастаңыз.',
	covid19SampleTitle: 'COVID DashboaCOVID бақылау тақтасы',
	covid19SampleDescription: 'Осы Cognos Dashboard тақтасымен COVID-19 қатысты деректерді және пайдаланушылық кеңейтімдерді талдай отырып, мүмкін өнерді зерттеңіз.',
	sankeySampleTitle: 'Санкей',
	sankeySampleDescription: 'Көрнекілендіру кітапханасын Sankey Chart сияқты жеке көрнекілендірумен кеңейтіңіз.',
	viewAllSamplesActionLabel: 'Барлық үлгілерді қарау',
	byFeatureTitle: 'Мүмкіндігі бойынша',
	byFeatureDescription: 'Негізгі функционалдылық, теңшелетін басқару элементтері, кеңейтімдер, notebooks бағдарламалары және салыстырмалы күндер сияқты ерекшеліктер бойынша үлгілерді шолу.',
	byIndustryTitle: 'Саласы бойынша',
	byIndustryDescription: 'Автокөлік, банк қызметі және басқалары сияқты салалар бойынша үлгілерді шолу.',
	// SamplesTab
	sampleTabTitle: 'Біздің алдын-ала жасалған үлгілермен шабыттаныңыз',
	sampleTabLabel: 'Accelator Каталогына IBM, серіктестер мен клиенттердің қосымша үлгілері мен кеңейтімдері үшін кіріңіз',

	// quickLaunch
	quickLaunchLabel: 'Жылдам іске қосу',
	expand: 'Кеңейту',
	collapse: 'Тасалау',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Жасағыңыз келетін нәрсені таңдаудан бастаңыз.',

	// contentPageView
	contentPageTitleLabel: 'Мазмұн',
	uploadFile: 'Деректерді жүктеп салу',
	new: 'Жаңа',
	create: 'Жасау',
	more: 'Қосымша',

	// open dialog
	selectDataSourcesToAdd: 'Қосылатын деректер көздерін таңдаңыз.',
	openDialogDefaultTitle: 'Ашу',

	// save dialog
	save: 'Сақтау',
	saveAs: 'Басқаша сақтау',
	saving: 'Сақтауда...',
	selectedDestination: 'Таңдалған бағыт: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' басқа түрімен бұрыннан бар. Басқа ат таңдаңыз.',
	confirmOverwriteTitle: 'Бұрыннан бар деректі алмастыруды құптау',
	confirmOverwriteMsg: '\'%{nameOfFile}\' файлы бұрыннан бар. Бұл деректерді файл ішінде қамтылған деректер орнын ауыстыруды қалайсыз ба?',

	// copy move dialog
	copy: 'Көшіру',
	move: 'Жылжыту',
	copyOrMove: 'Көшіру немесе жылжыту: ',
	copyOnly: 'Көшіру ',
	createShortcut: 'Сілтеме жасау',
	createShortcutDialogTitle: 'Сілтеме жасау: ',

	// External asset types
	wsProject: 'Watson Studio жобасы',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Бума',
	dataModule: 'Деректер модулі',
	exploration: 'Зерттеу',
	mode: 'Режим',
	live: 'Тікелей',
	snapshot: 'Сурет',
	noSnapshotsFound: 'Ешқандай сурет табылмады',
	uploadedFile: 'Жүктелген файл',
	fileUpload: 'Деректерді жүктеп салу',
	dataSetEx: 'Деректер орнатуы',
	externalRepository: 'Сыртқы репозиторий',
	queryMode: 'Сұрау күйі',
	queryModeCompatible: 'Сыйысымды',
	queryModeDynamic: 'Динамикалық',
	report: 'Есеп',
	activeReport: 'Белсенді есеп',
	query: 'Сұрау',
	analysis: 'Талдау',
	dashboard: 'Бақылау тақтасы',
	dashboardTemplate: 'Бақылау тақтасының үлгісі',
	jupyterNotebook: 'Notebook',
	wsNotebook: 'Watson Studio notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Мәтіндік бөлік',
	workspace: 'Жұмыс кеңістігі',
	pagelet: 'Бет',
	content: 'Мазмұн',
	directory: 'Атау кеңістіктері',
	dataSet: 'Деректер орнатуы',
	powerPlayCube: 'PowerPlay текшесі',
	powerPlayReport: 'PowerPlay есебі',
	powerPlay8Report: 'PowerPlay есебі',
	powerPlay8ReportView: 'PowerPlay есеп көрінісі',
	reportTemplate: 'Есеп үлгісі',
	packageConfigurations: 'Бума теңшелімі',
	agent: 'Агент',
	agentDefinition: 'Агент анықтамасы',
	agentDefinitionView: 'Агент көрінісі',
	dataMovementTask: 'Дерек тасымалының тапсырмасы',
	dataMovementTaskAlias: 'Дерек тасымалының тапсырмасының бүркеніш аты',
	document: 'Құжат',
	DocumentRetention: 'ҚҰжат сипаттары',
	jobDefinition: 'Жұмыс анықтамасы',
	job: 'Жұмыс',
	metricsDataSourceETLTask: 'Метрикалар деректер көзінің ETL тапсырмасы',
	metricsExportTask: 'Метрикаларды экспорттау тапсырмасы',
	metricsFileImportTask: 'Метрикалар файлын импорттау тапсырмасы',
	metricsMaintenanceTask: 'Метрикаларды сақтау тапсырмасы',
	planningTask: 'Жоспарлау тапсырмасы',
	shortcut: 'Таңбаша',
	URL: 'URL мекен-жайы',
	launchable: 'Іске қосылатын',
	dataSetFolder: 'Деректер жиынтыңының қалтасы',
	ViewAccessibleLabel: '%{label} қарау',
	overrideReportOptions: 'Әдепкі есеп опцияларін қайта жазу',
	formats: 'Пішімдер',
	saveReport: 'Есепті сақтау',
	promptForValues: 'Менен сұрау',
	reportView: 'Есеп көрінісі',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel деректері',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Мәліметтер',
	open: 'Ашу',
	created: 'Жасалған',
	modified: 'Өзгертілген',
	owner: 'Иесі',
	dataSource: 'Деректер көзі',
	share: 'Ортақ пайдалану',
	addToFavorites: 'Таңдаулыларға қосу',
	properties: 'Сипаттар',
	detailsEmptyStateBody: 'Мәліметтерін көру үшін элементті таңдаңыз',
	editNameAndDescription: 'Аты мен сипаттамасын өңдеу',
	none: 'Ешбір',

	//rename dialog
	nameInvalid: 'Атау жарамсыз',
	namePlaceholder: 'Ат енгізу',
	description: 'Сипаттама',
	descriptionInvalid: 'Сипаттама 350 таңбадан аспауы керек.',
	descriptionPlaceholder: 'Сипаттаманы енгізіңіз',
	errorMessageApostropheError: 'Екі \' және " таңбаларын қамтымайтын файл атауын енгізіңіз',
	renameCollisionError: '%{name} бұрыннан бар. Басқа атты көріңіз.',
	unknownRenameError: 'Элементтің атауы өзгертілмеді. Қосымша көмек алу үшін әкімшіңізге хабарласыңыз.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Көрсетілген қалтаны ашу мүмкін емес.',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}-ға жүктеңіз",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеп %{launchAction} іске қосыңыз",
	quickUpload: "Жылдам жүктеу",
	quickUploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеу үшін файлдарды сүйреп апарыңыз және келесі бос орындардың бірінде ашыңыз.",
	unsupportedFilesSingle: "%{files} жүктелмеді, себебі ол жылдам іске қосу үшін жарамсыз.",
	unsupportedFilesMultiple: "Файлдар кері жүктелмеді, себебі таңдалған барлық файлдар жылдам іске қосуын пайдалану үшін жарамды болуы керек.",
	unsupportedFilesSingleInvalid: "%{files} жарамсыз.",
	unsupportedFilesMultipleInvalid: "%{files} жарамсыз.",
	supportedFileTypes: "Тек келесі файл түрлеріне рұқсат етіледі: %{extensions}.",
	uploadDragAndDrop: "Апарып тастау",
	uploadDragAndDropMessage: "Файлды <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеу үшін оны сүйреп апарыңыз",

	// searchBar
	searchWasSaved: 'Іздеу критерийлері \'%{searchTerm}\' сақталды.',
	searchWasntSaved: 'Іздеу критерийлері \'%{searchTerm}\' сақталмады.',
	searchSuggestions: 'Ұсыныстар',
	savedSearch: 'Сақталған іздеулер',
	searchWasDeleted: 'Іздеу критерийлері \'%{searchTerm}\' жойылды.',
	searchWasntDeleted: '\'%{searchTerm}\' іздеу критерийлері жойылған жоқ.',
	savedBarTitle: 'Cognos Analytics іздеу',
	searchContentPageTitle: 'Іздеу',
	searchContentPageTitleLabel: '\'%{searchTerm}\' нәтижелерін көрсету',
	showingSearchRsult: '%{resultCount} элементтерін көрсету',
	saveSearch: 'Іздеуді сақтау',
	saveTenSearches: '10 іздеуді сақтай аласыз.',
	deleteASearch: 'Өзгесін сақтау үшін біреуін жойыңыз.',
	close: 'Жабу',

	//recent view
	recents: 'Соңғы',
	noAccessRecent: 'Кіруге болмайды',
	noAccessRecentMsg: 'Бұл активке рұқсатыңыз жоқ. Ол ажыратылған немесе жойылған немесе сіздің рұқсаттарыңыз азайған болуы мүмкін. Активтің жай-күйін күтілетін бастапқы орында тұрған жерінде тексеріңіз. Соңғы элементтерден активті OK түймешігін басу арқылы жоюға болады.',
	noAccessMsg: 'Бұл активке рұқсатыңыз жоқ. Ол ажыратылған немесе жойылған немесе сіздің рұқсаттарыңыз азайған болуы мүмкін.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} элемент таңдалды',
	itemSelected: '%{nameOfSelection} элемент таңдалды'

});